import React, { useEffect, useMemo, useState } from "react";
import AdvanceTableWrapper from "modules/common/advance-table/AdvanceTableWrapper";
import AdvanceTable from "modules/common/advance-table/AdvanceTable";
import CallIcon from "assets/svgs/table_call";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useCall } from "./store";
import CallCut from "assets/svgs/call_cut.js";
import Reschedule from "./Reschedule";
import PrescriptionFeedbackForm from "../feedback_form/PrescriptionFeedback";
import FeedbackForm from "../feedback_form/FeedbackForm";
import { getFormattedDate } from "modules/utilities/utility";
import NoData from "assets/svgs/no_data/NoData";
import { useBookingData } from "modules/nextcall/store";

function Booking({ customer, bookings, setMessageFloater }) {
  const { setToaster } = useToast();
  const { call } = useCall();

  const [callIcon, setCallIcon] = useState(<CallIcon />);
  const { sortedEngagementFirstElemId } = useBookingData();

  const formSelection = (week, booking) => {
    switch (week) {
      case "Prescription Call":
        return (
          <PrescriptionFeedbackForm
            week={booking.tag}
            id={booking._id}
            bookingId={booking.booking_reference_id}
          />
        );

      default:
        return (
          <FeedbackForm
            customer={customer}
            data={booking}
            list={true}
            week={booking.tag}
            id={booking._id}
            bookingId={booking.booking_reference_id}
            customerId={customer.id}
          />
        );
    }
  };
  useEffect(() => {
    setMessageFloater(true);
  }, []);

  const tableData = useMemo(() => {
    return bookings?.length
      ? (bookings || [])?.map((item) => {
          return {
            due_date: getFormattedDate(item?.reminder_date),
            tag: item?.tag,
            status: item?.status,
            case_id: customer.user.id,
            phone_number: customer.user.phone_number,
            booking_id: item?._id,
            booking_tag: item?.tag,
            booking: item,
          };
        })
      : [];
  }, [bookings]);

  const columns = [
    {
      accessor: "due_date",
      Header: "Due date",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "tag",
      Header: "Tag",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "status",
      Header: "Status",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "",
      Header: "Action",
      headerProps: { className: "text-900" },
      Cell: (rowData) => {
        const { case_id, due_date, tag, booking, booking_id, phone_number } =
          rowData.row.original;
        return (
          <div className="d-flex gap-1">
            <span
              className="flex-1 cursor-pointer mx-2"
              onClick={() => {
                setCallIcon(<CallCut />);
                call(case_id, {}, sortedEngagementFirstElemId, phone_number, setToaster);
              }}
            >
              {callIcon}
            </span>
            <span className="flex-1">
              {tag !== "SLOT_BOOKING" && (
                <Reschedule id={booking_id} dueDate={due_date} list={true} />
              )}
            </span>
            <span className="flex-1">{formSelection(tag, booking)}</span>
          </div>
        );
      },
    },
  ];

  return tableData?.length ? (
    <AdvanceTableWrapper columns={columns} data={tableData}>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: "fs-10 mb-0 overflow-hidden",
        }}
      />
    </AdvanceTableWrapper>
  ) : (
    <div className="text-center border p-2 rounded">
      Data is not available <NoData />
    </div>
  );
}

export default Booking;